import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Row, Col, Input, Button } from 'antd';
import { makeStyles } from '@material-ui/styles';

import { useClickAway } from 'common/hooks';

const useStyles = makeStyles(theme => ({
  wrapper: {
    width: 240,
    background: '#fff',
  },
  main: {
    padding: '12px',
  },
  input: {
    '& input': {
      width: 214,
      paddingLeft: 8,
      fontSize: 14,
      paddingRight: '8px !important',

      '&::placeholder': {
        fontSize: 14,
      },
    },
  },
  footer: {
    padding: '10px 12px 13px',
    textAlign: 'right',
    borderTop: '1px solid #e8e8e8',
  },
  resetBtn: ({ value }) => ({
    display: 'inline-block',
    width: 49,
    height: 24,
    lineHeight: '24px',
    textAlign: 'center',
    marginRight: 12,
    fontSize: 12,
    cursor: value ? 'pointer' : 'not-allowed',
    color: value ? theme.colors.bodyColor : theme.colors.disableColor,
    boxShadow: 'none',
    borderRadius: 2,

    '&:hover': {
      backgroundColor: value ? '#f5f5f5' : 'transparent',
    },
  }),
  searchBtn: {
    fontSize: 12,
    paddingLeft: 8,
    paddingRight: 8,
    boxShadow: 'none',
  },
}));

const SearchInputComponent = ({ field, value: initialValue, onChange }) => {
  const { t } = useTranslation();

  const wrapperRef = useRef(null);
  const [value, setValue] = useState(initialValue);

  const classes = useStyles({ value: initialValue });

  const handleInputChange = ev => {
    const value = ev.target.value;

    setValue(value);
  };

  const handleSearchClick = () => {
    onChange(field, value);
  };

  const handleResetClick = () => {
    setValue(null);
    onChange(field, null);
  };

  useClickAway(wrapperRef, () => setValue(initialValue), ['click']);

  return (
    <Row className={classes.wrapper} ref={wrapperRef}>
      <Col span={24} className={classes.main}>
        <Input
          allowClear
          name={field}
          className={classes.input}
          placeholder={t('cms:cms.landlord_account.table.input.placeholder')}
          value={value}
          onPressEnter={handleSearchClick}
          onChange={handleInputChange}
        />
      </Col>
      <Col span={24} className={classes.footer}>
        <span className={classes.resetBtn} onClick={handleResetClick}>
          {t('cms:cms.landlord_account.table.reset')}
        </span>
        <Button
          size="small"
          type="primary"
          className={classes.searchBtn}
          onClick={handleSearchClick}
        >
          {t('cms:cms.landlord_account.table.search')}
        </Button>
      </Col>
    </Row>
  );
};

SearchInputComponent.propTypes = {
  field: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

SearchInputComponent.defaultProps = {
  value: null,
};

export default SearchInputComponent;
